export type TravelPlanServiceType =
  | 'Walk'
  | 'Bike'
  | 'Public'
  | 'Drive'
  | 'ParkAndRide'
  | 'CycleToTrainStation'
  | 'DriveToTrainStation'
  | 'CarshareToTrainStation'
  | 'Carshare'
  | 'CommunityTransport';


export enum ContactPreferenceType {
  MarketingInformation = 0,
  Surveys = 1,
  TravelPlans = 2,
}

export enum OutboundType {
  LeavingAt,
  ArriveBy,
}

export enum ReturnType {
  LeavingAt,
  ReturnBy,
}

export enum LocationType {
  Origin,
  Destination,
}

export enum TravelPlanLegType {
  Outbound,
  Return,
}

export enum PtpTabStatus {
  Draft,
  Results,
  Breakdown,
  Liftshare,
}

export enum JourneyType {
  Passenger = 1,
  Driver = 2,
  Both = 3,
}

export enum JourneyFrequency {
  OneOff = 1,
  Regular = 2,
  Occasional = 3,
  Shift = 4,
}

export enum PassengerOrDriver {
  Passenger,
  Driver,
}

export enum GoogleTransitDetails {
  BUS, // - Bus.
  CABLE_CAR, // - A vehicle that operates on a cable, usually on the ground. Aerial cable cars may be of the type GONDOLA_LIFT.
  COMMUTER_TRAIN, // - Commuter rail.
  FERRY, //- Ferry.
  FUNICULAR, // - A vehicle that is pulled up a steep incline by a cable. A Funicular typically consists of two cars, with each car acting as a counterweight for the other.
  GONDOLA_LIFT, // - An aerial cable car.
  HEAVY_RAIL, //- Heavy rail.
  HIGH_SPEED_TRAIN, // - High speed train.
  INTERCITY_BUS, //- Intercity bus.
  LONG_DISTANCE_TRAIN, // - Long distance train.
  METRO_RAIL, //- Light rail transit.
  MONORAIL, //- Monorail.
  OTHER, //- All other vehicles will return this type.
  RAIL, //- Rail.
  SHARE_TAXI, // - Share taxi is a kind of bus with the ability to drop off and pick up passengers anywhere on its route.
  SUBWAY, //- Underground light rail.
  TRAM, //- Above ground light rail.
  TROLLEYBUS, // - Trolleybus
}

export enum GoogleTravelMode {
  Driving,
  Walking,
  Bicycling,
  Transit,
}

export enum GeoRestrictionType {
  Geofence = 0,
  DefinedDestinations = 1,
}
